import { PayerKind, useSearchPayers } from "api/hooks/useHCPs";

export function usePortalPayerOptions(kind: PayerKind) {
  const { data: payers, error, isError, isLoading } = useSearchPayers("", kind);

  return {
    error,
    isError,
    isLoading,
    options:
      payers?.items?.map(payer => ({
        label: payer.name,
        value: payer.id.toString(),
      })) ?? [],
  };
}
